import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';

const InactivityWarning = ({ open, secondsRemaining }) => {
    return (
        <Dialog 
            open={open} 
            maxWidth="sm"
            fullWidth
            sx={{ zIndex: 9999 }}
        >
            <DialogTitle className="text-center">
                Session Timeout Warning
            </DialogTitle>
            <DialogContent className="text-center">
                <div className="mb-5">
                    Your session will expire in{' '}
                    <span className="font-bold text-red-600">{secondsRemaining}</span> seconds due to inactivity.
                </div>
                <div className="text-gray-600 text-sm">
                    If you want to stay logged in, move your mouse within this window.
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default InactivityWarning;